(function () {
  /**
   * @deprecated - please use src2/core/services/directory/directoryConstants.js
   */
  angular.module('binky.core.directory-sync').constant('DIRECTORY_SYNC_EVENT', {
    DOMAIN_SYNCED: 'DomainSynced',
  });
})();
